
import { Condition } from "@JSX";
import { RedirectAuth } from "@mosanic/auth";
import { useGetSite } from "@mosanic/cms/Query/byId";
import { HeaderProvider } from "@mosanic/core/Provider";
import { Preview } from "@mosanic/core/Screens";

import { FontSources } from "@mosanic/core/Typography/RenderFontSources";
import { siteIdSelector } from "@redux/auth/reducer";
import { getAutoSavePref, isPreviewCanvasSelector } from "@redux/options/reducer";
import { pageMetaAttrSelector } from "@redux/pages/reducer";
import { initializeScreens } from "@redux/screens/action";
import dynamic from "next/dynamic";
import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
 

const BuilderWrapper = dynamic(() => import(
    /* webpackChunkName: 'BuilderWrapper' */
    "../../../components/Builder/Canvas/Wrapper"
  ), {
  ssr: false
})

const Tour = dynamic(() => import(
  /* webpackChunkName: 'Builder Tour' */
  "@mosanic/core/Tour"
), {
  ssr: false,
})
const KeyListeners = dynamic(() => import(
  /* webpackChunkName: 'Builder Tour' */
  "@mosanic/core/Keys"
), {
  ssr: false,
})

import { CanvasControls } from "src/components/Builder/Canvas";
import { FieldMenu } from "src/components/Builder/Tabs";

const fiveMin = 300000

 
const Builder = ({}) => {
  const dispatch = useDispatch();

  const siteId = useSelector(siteIdSelector)
    const [site] = useGetSite({_id: siteId})
  const {nav, locales} = site || {nav: null, locales: null};

  const type = useSelector(state => pageMetaAttrSelector(state, 'type'))

  const autoSave = useSelector(getAutoSavePref)

  const previewCanvas = useSelector(isPreviewCanvasSelector)
 
  useEffect(() => {
    dispatch(initializeScreens())
  },[dispatch])

  useEffect(() => {
    let interval = null
    if(autoSave) {
      interval = setInterval(() => {
        // alert('save')
      }, fiveMin);
    }
    return () => clearInterval(interval)
  }, [])



  // useEffect(() => {
  //   router.replace({
  //       pathname: replacePart(router.pathname, '/app', ''),
  //       query: previewCanvas ? {
  //           page: current 
  //       } : null
  //   }, undefined, {shallow: true})
  // },[current, previewCanvas, router])


  return (
    <Condition when={type === 'header'} wrapper={children => (
        <HeaderProvider nav={nav} locales={locales} >
            {children}
        </HeaderProvider>
    )}>
      {previewCanvas ? (
        <Preview />
      ): (
        <>
          <RedirectAuth />
          <BuilderWrapper/>
                 
          <CanvasControls />
          <FontSources dynamic/>   
          <KeyListeners />   
          {/* <FieldMenu /> */}
          <Tour />
        </>
      )}
    </Condition>
  )
};


export default memo(Builder);
